import { Avatar } from "@mui/material";
import { Apps } from "@mui/icons-material";
import type { IClientAppSummary } from "@ids/shared";

function getInitials(name: string): string {
    const words = name.trim().split(/\s+/).filter(Boolean);
    if (words.length >= 2) {
        return (words[0][0] + words[words.length - 1][0])
            .toUpperCase()
            .slice(0, 2);
    }
    return name.slice(0, 2).toUpperCase() || "?";
}

interface ClientAppAvatarProps {
    app?: Pick<IClientAppSummary, "name" | "icon"> | null;
    size?: number;
    emphasized?: boolean;
}

export const ClientAppAvatar = ({
    app,
    size = 44,
    emphasized = false
}: ClientAppAvatarProps) => {
    const name = app?.name ?? "Anwendung";
    const icon = app?.icon;
    const src =
        icon?.data && icon?.contentType
            ? `data:${icon.contentType};base64,${icon.data}`
            : undefined;

    return (
        <Avatar
            src={src}
            alt={name}
            sx={{
                width: size,
                height: size,
                flexShrink: 0,
                bgcolor: emphasized ? "primary.main" : "action.hover",
                color: emphasized ? "primary.contrastText" : "text.secondary",
                fontSize: "0.875rem",
                fontWeight: 700
            }}
        >
            {src ? null : getInitials(name) || <Apps fontSize="small" />}
        </Avatar>
    );
};
